import React from 'react';
import fm from 'format-message';
import PropTypes from 'prop-types';
import media from '@activebrands/core-web/config/media';
import { styled } from '@activebrands/core-web/libs/styletron';
import Heading from 'components/text/Heading';
import Paragraph from 'components/text/Paragraph';

const Wrapper = styled('div', {
    display: 'flex',
    width: '100%',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
});

const TextContent = styled('div', {
    display: 'flex',
    width: '100%',
    flexDirection: 'column',
    alignItems: 'center',
    maxWidth: '100%',
    textAlign: 'center',
    margin: '32px 0',
    [media.min.tabletSm]: {
        margin: '40px 0',
        maxWidth: '70%',
    },
});

const Elem = typeof Element === 'undefined' ? function () {} : Element;

const PaymentError = ({ paymentErrorRef }) => (
    // TODO: Translations are going to be replaced with CMS data in the future
    <Wrapper ref={paymentErrorRef}>
        <TextContent>
            <Heading $style={{ margin: '0 0 16px 0' }} as="h6" textStyles="Founders Grotesk/16-100">
                {fm('Something went wrong with the payment')}
            </Heading>
            <Paragraph $style={{ margin: '0 0 16px 0' }} textStyles="Founders Grotesk/14-100">
                {fm('Please try again, or contact customer service')}
            </Paragraph>
        </TextContent>
    </Wrapper>
);
PaymentError.propTypes = {
    paymentErrorRef: PropTypes.oneOfType([PropTypes.func, PropTypes.shape({ current: PropTypes.instanceOf(Elem) })]),
};

PaymentError.defaultProps = {
    paymentErrorRef: null,
};

export default PaymentError;
